<template>
    <RemoteTable ref="table" :form="form" :table="table">
        <template #default="{row, property}">
            <template v-if="property === 'code'">
                {{$root.getBusinessName(row.code)}}
            </template>
            <template v-else-if="property === 'count'">
                {{row.success + row.unknown}}
            </template>
            <template v-else-if="property === 'rate'">
                {{getRate(row)}}
            </template>
        </template>
    </RemoteTable>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: [
                        {label: "业务", name: "code", type: "cascade", op: "beginwith", value: ""},
                        {label: "日期", name: "date", type: "daterange", op: "between", value: []},
                        {label: "类型", name: "type", type: "select", url: "/dict/list/summary/type", value: ""},
                        {label: "备注", name: "remark", type: "input", op: "contains"},
                    ],
                    tools: [
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/summary/download', this.$refs.table.getQueryInfo()).then(response => {
                                  this.$utils.download("/file/pop/" + response);
                                });
                              });
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/summary",
                    defaultSort: {prop: 'id', order: 'descending'},
                    columns: [
                        {label: "日期", name: "date", width: 100},
                        {label: "业务名称", name: "code", sortable: true},
                        {label: "类型", name: "type", width: 120, sortable: true},
                        {label: "有效号码数", name: "num", width: 120, sortable: true},
                        {label: "预计费数", name: "total", width: 100, sortable: true},
                        {label: "成功数", name: "success", width: 100, sortable: true},
                        {label: "失败数", name: "fail", width: 100, sortable: true},
                        {label: "无状态数", name: "unknown", width: 100, sortable: true},
                        {label: "实计费数", name: "count", width: 100, sortable: true},
                        {label: "成功率", name: "rate", width: 100},
                        {label: "备注", name: "remark", width: 300},
                        {label: "国家", name: "country", width: 100},
                    ],
                }
            }
        },
        methods: {
            getRate(row) {
                let total = row.success + row.fail + row.unknown;
                if (total === 0) {
                    return "--";
                }
                return ((row.success + row.unknown) / total * 100).toFixed(2) + "%";
            }
        }
    }
</script>